import React, { memo } from 'react';
import PropTypes from 'prop-types';

import Grid from '@material-ui/core/Grid';
import { Tooltip } from 'core/components/tooltip';
import useStyles from './tooltip-wrapper.styles';
import classNames from 'classnames';

const TooltipWrapper = memo(({ children, classes, xs, tooltip: { text, label }, iconOnly = false }) => {
  const localClasses = useStyles();
  const tooltipLabel = iconOnly ? '' : label || 'More Info';

  return (
    <Grid item xs={xs} className={classNames(localClasses.container, classes.containerClasses)}>
      <Tooltip className={classes.tooltipClasses} text={text} label={tooltipLabel} formField />
      {children}
    </Grid>
  );
});

TooltipWrapper.propTypes = {
  children: PropTypes.node.isRequired,
  classes: PropTypes.shape({
    containerClasses: PropTypes.string,
    tooltipClasses: PropTypes.string
  }),
  tooltip: PropTypes.shape({
    text: PropTypes.string.isRequired,
    label: PropTypes.string
  }).isRequired,
  xs: PropTypes.number
};

TooltipWrapper.defaultProps = {
  classes: {},
  xs: undefined
};

TooltipWrapper.displayName = 'TooltipWrapper';

export default TooltipWrapper;
